import { AccountAddressFragment } from '@graphcommerce/magento-customer/components/AccountAddress/AccountAddress.gql'
import { Spinner } from '../../Spinner'
import { AddressSingleLine } from '../AddressSingleLine/AddressSingleLine'

export type AccountAddressProps = AccountAddressFragment & { loading?: boolean }

export function AccountAddress(props: AccountAddressProps) {
  const { id, loading = false, ...addressProps } = props

  return (
    <div className='flex items-center gap-[10px]'>
      <AddressSingleLine id={id} {...addressProps} />
      {loading && <Spinner />}
    </div>
  )
}
